import { FC, ReactElement } from 'react';

import { Picture } from '../../../../components';
import { useTrans } from '../../../../hooks';
import {
    PAYMENT_METHOD_APPLE_PAY,
    PAYMENT_METHOD_GIFTCARD,
    PAYMENT_METHOD_GOOGLE_PAY,
    PAYMENT_METHOD_IDEAL,
    PAYMENT_METHOD_IN3,
    PAYMENT_METHOD_MAESTRO,
    PAYMENT_METHOD_MASTERCARD,
    PAYMENT_METHOD_RIVERTY,
    PAYMENT_METHOD_VISA,
} from '../../../../mock/mock-data';

import './PaymentMethods.scss';

interface PaymentMethodsProps {
    className?: string;
}

export const PaymentMethods: FC<PaymentMethodsProps> = ({
    className = '',
}): ReactElement => {
    const trans = useTrans();

    const paymentMethods = [
        PAYMENT_METHOD_GIFTCARD,
        PAYMENT_METHOD_IDEAL,
        PAYMENT_METHOD_APPLE_PAY,
        PAYMENT_METHOD_GOOGLE_PAY,
        PAYMENT_METHOD_IN3,
        PAYMENT_METHOD_RIVERTY,
        PAYMENT_METHOD_MAESTRO,
        PAYMENT_METHOD_MASTERCARD,
        PAYMENT_METHOD_VISA,
    ];

    return (
        <div className={`payment-methods ${className}`}>
            <p className="payment-methods__header">
                {trans('containers.checkout.paymentMethods.paySafe')}
            </p>

            <div className="payment-methods__methods-wrapper">
                {paymentMethods.map((paymentMethod) => (
                    <Picture
                        {...paymentMethod}
                        key={paymentMethod.alt}
                        className="payment-methods__picture"
                    />
                ))}
            </div>
        </div>
    );
};
